import {
  CLEAR_FILIAL_FUNCIONARIO_ID,
  SET_FILIAL_FUNCIONARIO_ID
} from './types'

export const clearFilialFuncionarioId = () => ({ type: CLEAR_FILIAL_FUNCIONARIO_ID });

export const setFilialFuncionarioId = id => dispatch => dispatch({ type: SET_FILIAL_FUNCIONARIO_ID, payload: id });